

























































































import { Component, Vue } from "vue-property-decorator";

declare let google: any;
const geocoder = new google.maps.Geocoder();
const directionsService = new google.maps.DirectionsService();
const directionsDisplay = new google.maps.DirectionsRenderer({
  suppressMarkers: true,
  polylineOptions: {
    strokeColor: "#009C82",
    strokeWidth: 1,
  },
});

@Component
export default class MapsGenerator extends Vue {
  map: any;
  mapStyles: any = {
    width: "100%",
    height: "650px",
  };
  mapOptions: any = {
    center: { lat: 51.3363, lng: 7.47149 },
    zoom: 13,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: false,
    clickableIcons: false,
    scrollwheel: false,
    gestureHandling: "greedy",
    class: "map-marker",
    styles: [
      {
        elementType: "geometry",
        stylers: [
          {
            color: "#212121",
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#212121",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "administrative.country",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#181818",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#1b1b1b",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#2c2c2c",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#8a8a8a",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#373737",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            color: "#3c3c3c",
          },
        ],
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "geometry",
        stylers: [
          {
            color: "#4e4e4e",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#3d3d3d",
          },
        ],
      },
    ],
  };
  location: any = {
    name: "Ultrapixel GbR",
    telefon: "02331 - 1885252",
    email: "info@ultrapixel.de",
    str: "Zur Höhe 47a",
    plz: "58091",
    ort: "hagen",
  };
  mapLoaded: any = false;
  infoOpened: any = false;
  infoOpenedRoute: any = false;
  departureAddress: any = null;
  errorMessage: any = null;
  route: any = {};
  isRouteCalculated: any = false;

  initMap() {
    this.mapLoaded = true;
    this.map = new google.maps.Map(
      document.getElementById("map"),
      this.mapOptions
    );
    const markerImage =
      "https://ultrapixel.de/download_file/64/0";
    this.addMarker(this.mapOptions.center, markerImage, true);
  }

  addMarker(location: any, markerImage: any, clickable?: boolean) {
    const markerCenter = location;
    const marker = new google.maps.Marker({
      map: this.map,
      position: markerCenter,
      height: "32px",
      width: "32px",
      icon: markerImage
    });
    if (clickable) {
      marker.addListener("click", () => {
        this.toggleInfo();
      });
    }
  }

  toggleInfo() {
    this.infoOpened = !this.infoOpened;
  }

  toggleRoute() {
    if (this.infoOpened && !this.infoOpenedRoute)
      this.infoOpenedRoute = !this.infoOpenedRoute;
  }

  calculatedRoute() {
    const address = this.departureAddress;
    const position = new google.maps.LatLng(
      this.mapOptions.center.lat,
      this.mapOptions.center.lng
    );
    geocoder.geocode({ address: address }, (results: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK) {
        console.log(google.maps.GeocoderStatus);
        const markerImage =
          "https://ultrapixel.de/download_file/65/0";
        const location: any = {
          city: "Hagen",
          position: {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          },
        };
        this.addMarker(location.position, markerImage);
      } else {
        console.log(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
    directionsDisplay.setMap(this.map);
    const routeObject: any = {
      distance: "",
      duration: "",
      start: "",
      end: "",
      steps: [],
    };
    directionsService.route(
      {
        origin: this.departureAddress,
        destination: position,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response: any, status: any) => {
        if (status === google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
          routeObject.distance = response.routes[0].legs[0].distance.text;
          routeObject.duration = response.routes[0].legs[0].duration.text;
          routeObject.start = response.routes[0].legs[0].start_address;
          routeObject.end = response.routes[0].legs[0].end_address;
          Object.keys(response.routes[0].legs[0].steps).forEach((key) => {
            const routeStep = {
              distance: "",
              duration: "",
              instruction: "",
            };
            let str = response.routes[0].legs[0].steps[key].instructions;
            for (let i = 0; i < str.length; i++) {
              str = str.replace("<b>", "");
              str = str.replace("</b>", "");
              str = str.replace('<div style="font-size:0.9em">', ". ");
              str = str.replace("<div>", "");
              str = str.replace("</div>", "");
              str = str.replace("/<wbr/>", " ");
            }
            routeStep.distance =
              response.routes[0].legs[0].steps[key].distance.text;
            routeStep.duration =
              response.routes[0].legs[0].steps[key].duration.text;
            routeStep.instruction = str;
            routeObject.steps.push(routeStep);
          });
          this.errorMessage = null;
        } else {
          this.isRouteCalculated = false;
          this.errorMessage = "Adresse " + status;
        }
      }
    );
    this.route = routeObject;
  }
}
